import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {Fruits} from "../Fruits";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {FruitsParsedGameData} from "../server/data/FruitsParsedGameData";
import { FruitsGameModuleConfig } from "../FruitsGameModuleConfig";


export class FruitsBeforeSpinStopRandomFeatureController extends BeforeSpinStopPresentationController {
    private _randomOverlayTriggered:boolean;
    private _randomOverlaySymbol:string;
    private _randomOverlayPositions:boolean[][];
    private _numberOfOverlaySymbols:number;
    private _gameMode:FruitsGameMode;
    private _parsedRandomOverlayPositions:number[];

    constructor(index:number) {
        super(index, "FruitsBeforeSpinStopRandomFeatureController");
    }

    protected addFeatureEventHandlers():void{
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this.spinStopped());
    }

    protected parseFeatureTriggered(data:FruitsParsedGameData):boolean{
        this._gameMode = data.mode;

        this._randomOverlayTriggered = data.randomSymbolOverlayTriggered;
        this._randomOverlaySymbol = data.randomOverlaySymbol;
        this._randomOverlayPositions = data.symbolOverlayPositions;
        this._numberOfOverlaySymbols = data.numberOfOverlaySymbols;
        this._parsedRandomOverlayPositions =  data.parsedRandomOverlayPositions;

        if (this._randomOverlayTriggered) {
            FruitsGameModuleConfig.beforeSpinStopRandomFeatureView.prepareAssets(this._parsedRandomOverlayPositions, this._randomOverlaySymbol);
        }

        return this._randomOverlayTriggered;
    }



    protected getSpinStopDelay(data:FruitsParsedGameData):number{
        let coefficient = 1;
        if(GameSetting.isFastSpin){
            coefficient = 1.62
        }

        this._timeline.timeScale(coefficient);

        return this._timeline.totalDuration() / coefficient;
    }


    protected startPresentation(timeline:TimelineLite):void{
        timeline.add(FruitsGameModuleConfig.beforeSpinStopRandomFeatureView.getAnimation(), 1);
    }

    protected stopPresentation(isAborted:boolean):void{
        FruitsGameModuleConfig.beforeSpinStopRandomFeatureView.getDisappearAnimation();

    }


    public abort():void {
        if(this._isPlaying) {
            const tl:TimelineLite = new TimelineLite();

            tl.add(() => {
                this._isPlaying = false;
                this._isAborted = true;
                FruitsGameModuleConfig.beforeSpinStopRandomFeatureView._isAborted = true;
                this._timeline.totalDuration(0.5);
            });

        }
    }

    protected resetFeature():void{
    }


    private spinStopped():void{
        if (this._randomOverlayTriggered) {
            FruitsGameModuleConfig.beforeSpinStopRandomFeatureView.resetRandomFeature();
        }
    }

}